/**
 * @file index.tsx
 *
 * @fileoverview Exports job alert utils.
 */
import { Job } from '~/jobiqo/types/types';
import { getCookieFromBrowser, setBrowserCookie } from '~/jobiqo/lib/session';
import { UserContextInterface } from '~/jobiqo/context/user';

const JOB_ALERT_FREQUENCY_COOKIE = 'job_alert_frequency';
/**
 * Checks configuration to determine if the job alert modal should be opened.
 *
 * @param {Job} job
 *  The job to open modal for.
 * @param {UserContextInterface} user
 *  The current user.
 * @returns
 *  True if we should open a modal, false otherwise.
 */
export function shouldOpenJobAlertModal(
  { applicationWorkflow }: Job,
  { authenticated }: UserContextInterface,
  jobAlertModal,
) {
  // Do not open the job alert modal for authenticated users.
  if (authenticated) {
    return false;
  }

  const configIncludesWorkflow = jobAlertModal.APPLICABLE_JOB_APPLICATION_WORKFLOW.includes(
    applicationWorkflow,
  );

  // Return false immediately and skip cookie setup
  // for inapplicable job application workflow.
  if (!configIncludesWorkflow) {
    return false;
  }

  const cookieExpirationConfig = parseInt(jobAlertModal.FREQUENCY_DAYS);

  let isCookieValid = false;

  if (!isNaN(cookieExpirationConfig)) {
    // Check if the cookie is available.
    isCookieValid = !!getCookieFromBrowser(JOB_ALERT_FREQUENCY_COOKIE);

    // Set the cookie if it has expired or it is not available.
    if (!isCookieValid) {
      setBrowserCookie(
        JOB_ALERT_FREQUENCY_COOKIE,
        jobAlertModal.FREQUENCY_DAYS,
        {
          expires: cookieExpirationConfig,
        },
      );
    }
  }

  return !isCookieValid;
}
